// extracted by css-extract-rspack-plugin
export default {"parameterItem":"K8KR9","buttonLink":"B1EGa"};